import React  from 'react'
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Modal, Box, IconButton, TextField, Grid } from '@mui/material';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxSec from '../../../../pages/Settings/General-Settings/CheckBoxSec';

const AddHolidayPop = ({ openHolidayPop, handleCloseHolidayPop }) => {

    const modalMoveActivities = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '586px',
        width: '90%',
        margin: 'auto',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: '2px',
        // border: '2px solid #0B57D0'
        border: '2px solid transparent',
        backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        borderRadius: '12px',
    };



    const holidayList = [
        { label: 'Custom' },
        { label: 'Republic Day' },
        { label: 'Independence Day' },
        { label: 'Gandhi Jayanti' },
        { label: 'Holi' },
        { label: 'Eid al-Fitr' },
        { label: 'Diwali' },
        { label: 'Christmas' },
    ]

    return (
        <>

            <Modal open={openHolidayPop} fullWidth maxWidth="sm">
                <Box sx={{
                    ...modalMoveActivities,
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: '90vh',
                    overflow: 'hidden',
                }}>
                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                        <Box>
                            <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Add Holiday</Typography>
                        </Box>
                        <IconButton onClick={handleCloseHolidayPop} className='p-0'>
                            <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                        </IconButton>
                    </Box>
                    {/* End Header */}

                    {/* start Body sec  */}
                    <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                        <Box>
                            <Box sx={{ m: '0 auto 24px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <Box>
                                    <CalendarMonthOutlinedIcon sx={{ color: '#0076FE' }} />
                                </Box>
                                <Box sx={{ marginTop: '4px' }}>
                                    <Typography sx={{ color: '#0076FE', fontSize: '15px', fontWeight: '600' }}>
                                        Set up Holiday
                                    </Typography>
                                </Box>
                            </Box>
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope', marginBottom: '5px' }}>Holiday</Typography>
                                        <Autocomplete className='inpfieldclass'
                                            disablePortal
                                            options={holidayList}
                                            sx={{ width: '100%' }}
                                            renderInput={(params) => <TextField {...params} placeholder='Select Holiday' sx={{ height: '40px' }} />}
                                        />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={500} sx={{ fontSize: '13px', fontWeight: '500', fontFamily: 'Manrope', marginBottom: '5px' }}>Choose how you want to set up holidays</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Holiday name*</Typography>
                                        <TextField placeholder="Enter Holiday name" fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                                    <Box sx={{ m: '0 auto 5px' }}>
                                        <Typography color='#1A1F36' fontWeight={600} mb={0} sx={{ fontSize: '14px', fontWeight: '600', fontFamily: 'Manrope' }}>Paid hours*</Typography>
                                        <TextField placeholder="Enter Paid Hours" type='time' fullWidth size="small" fontWeight={400}
                                            sx={{ borderRadius: '6px', margin: '4px auto', fontSize: '14px', fontFamily: 'Manrope' }} />
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 12, lg: 12, xl: 12 }}>
                                    <Box display="flex" alignItems="center" sx={{ gap: '5px', margin: '8px auto 4px' }}>
                                        <CheckBoxSec projects={[{ name: true }]} />
                                        <Box>
                                            <Typography sx={{ fontSize: '15px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }}>Occurs annually</Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>

                    {/* End Body sec  */}

                    {/* start Footer sec  */}
                    <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                        <Button onClick={handleCloseHolidayPop} variant="outlined" className='bg-white text-capitalize' color="#1A1F36" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Cancel
                        </Button>
                        <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                            <Button variant="contained" color="primary" className='text-capitalize' sx={{ boxShadow: 'unset', backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* End Footer sec  */}
                </Box>
            </Modal>
        </>
    )
}

export default AddHolidayPop